import { useLocation, useSearchParams } from "react-router-dom";
// A custom hook that builds on useLocation to parse
// the query string for you.
export default function useQuery() {
  const [searchParams] = useSearchParams();
  return Object.fromEntries([...searchParams]);
}
